import { CircularProgress } from "@mui/material";
import styles from "../css/modules/components.module.scss";

export function Loading({ loadingText = "" }) {
  return (
    <div className={styles.loading}>
      <CircularProgress />
      {loadingText && <div className={styles.loadingText}>{loadingText}</div>}
    </div>
  );
}
